import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const alura: Collection = {
  id: 'sp-alura',
  brandId: 'sp',
  brandName: 'S|P Collection',
  icon: 'sp-collection.png',
  title: 'Alura',
  subTitle: 'Tijdloos',
  banner: 'alura/alura-banner.jpg',
  items: [
    {
      id: 'sp-alura-1',
      collectionImages: [
        {
          image: 'alura/Alura_5.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'alura/Alura_4.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'sp-alura-2',
      collectionImages: [
        {
          image: 'alura/Alura_7.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'alura/Alura_8.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    'ac4604d3-7fa0-429c-a4ee-53c13007914a',
    'd2f87332-9415-4da1-bb77-54bed42cb30a',
    '48c25f23-b450-4f81-8d53-d4e7b2b53652',
    '7566c078-673d-4a35-b5a6-089651b95c5f',
    '0dc2c706-d40c-43ac-85a5-33719030569a',
    '0f84fb81-b6cd-42ea-b458-b80aeb9f2111',
    'bfba0e84-3171-4930-b48f-b1ab98e81e24',
    '53cc7514-34c1-477e-9ec8-c478d4198f99',
    'c05527dc-29ae-4c75-8fd4-97e99b6a903f'
  ]
};
